import { render, staticRenderFns } from "./Checkboxes.vue?vue&type=template&id=74a19ac4&scoped=true&"
import script from "./Checkboxes.vue?vue&type=script&lang=js&"
export * from "./Checkboxes.vue?vue&type=script&lang=js&"
import style0 from "./Checkboxes.vue?vue&type=style&index=0&id=74a19ac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a19ac4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74a19ac4')) {
      api.createRecord('74a19ac4', component.options)
    } else {
      api.reload('74a19ac4', component.options)
    }
    module.hot.accept("./Checkboxes.vue?vue&type=template&id=74a19ac4&scoped=true&", function () {
      api.rerender('74a19ac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/profile/components/ProfileField/field-types/Checkboxes.vue"
export default component.exports